// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__D5cGH","outline":"button_outline__4Nyz4","large":"button_large__8-HQp","small":"button_small__9hp0D"};